import { TierRateByYear } from '../../interfaces';

export const rates: TierRateByYear = {
    2023: [
        { percentage: 32 },
    ],
    2024: [
        { percentage: 36 },
    ]
};
